export function write(name, value, days) {
    var expires = '',
        cookie,
        date,
        domain;

    if (days) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    }

    cookie = name + '=' + value + expires + '; path=/;';
    domain = _getCookieDomain(document.location.hostname);

    if (domain) {
        cookie = cookie + 'domain=' + domain + ';';
        cookie = cookie + 'Secure;';
    }

    document.cookie = cookie;
}

export function _getCookieDomain(hostname) {
    if (/(^|\.)smartpakequine\.com$/i.test(hostname)) {
        return '.smartpakequine.com';
    }

    if (/(^|\.)smartpak\.local$/i.test(hostname)) {
        return '.smartpak.local';
    }

    return null;
}

export function read(name) {
    var nameEq = name + '=',
        ca = document.cookie.split(';'),
        length,
        i,
        c;
    for (i = 0, length = ca.length; i < length; i++) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEq) === 0) {
            return c.substring(nameEq.length, c.length);
        }
    }
    return null;
}

export function erase(name) {
    write(name, '', -1);
}

export function parse(cookieName, extender) {
    var parsedCookie = {};

    parsedCookie.refreshCookieData = function() {
        var output = _parseQueryString(read(cookieName));

        Object.keys(output).forEach(function(key) {
            parsedCookie[key] = output[key];
        });

        if (extender && typeof extender === 'function') {
            extender(parsedCookie);
        }
    };

    parsedCookie.refreshCookieData();

    return parsedCookie;
}

export function _parseQueryString(queryStr) {
    var queryString = {},
        parts,
        i,
        item;

    if (typeof queryStr === 'undefined' || queryStr === null) {
        return queryString;
    }

    parts = queryStr
        .split('?')
        .pop()
        .split('&');
    i = parts.length;

    while (i--) {
        item = parts[i].split('=');
        queryString[item[0]] = decodeURI(item[1]);
    }

    return queryString;
}
